import React from 'react'
import Layout from './Layout'
import { Link } from 'react-router-dom'

export default function BasicElectricalEngineering() {
  return (
    <Layout page={
      <div>
        <h1>Basic Electrical Engineering</h1>
        <div>
          <h3>Module 1 Notes</h3>
          <ul>
            <Link to='/file/bee/Merged Module 1 Note.pdf'>Merged Module 1 Note.pdf</Link>
          </ul>
          <h3>Module 2 Notes</h3>
          <ul>
            <Link to='/file/bee/Module 2 Notes.pdf'>Module 2 Notes.pdf</Link>
          </ul>
          <h3>Module 3 Notes</h3>
          <ul>
            <Link to='/file/bee/Module 3 Notes.pdf'>Module 3 Notes.pdf</Link>
          </ul>
          <h3>Module 4 Notes</h3>
          <ul>
            <Link to='/file/bee/Module 4 Notes.pdf'>Module 4 Notes.pdf</Link>
          </ul>
          <h3>Module 5 notes</h3>
          <ul>
            <Link to='/file/bee/Module 5.pdf'>Module 5.pdf</Link>
          </ul>
          <h3>Lab Material Drive Link</h3>
          <ul>
            <a href='https://drive.google.com/drive/folders/1-q38-8hnG5KMOuBJPuhjNHPQeVxk1QCt' target='_blank'>https://drive.google.com/drive/folders/1-q38-8hnG5KMOuBJPuhjNHPQeVxk1QCt</a>
          </ul>
        </div>
      </div>
    } />
  )
}
